import React from "react";
import Box from "@mui/material/Box";
import Link from "next/link";
import Image from "next/image";

import { useI18n } from "@/i18n/I18nProvider";

/*
 * One icon + label entry inside a dropdown or a drawer section. `onNavigate`
 * is what closes whatever container the tile was rendered in.
 */
function ServiceTile({ img, title, url, onNavigate }) {
  const { locale } = useI18n();

  /*
   * The brokerage icon is taller than the rest and needs less breathing room
   * above it so the row of tiles stays aligned.
   */
  const isBrokerageIcon =
    img === "/services/bro-en.svg" || img === "/services/bro-ar.svg";

  return (
    <Box>
      <Box
        component={Link}
        href={url}
        onClick={onNavigate}
        sx={{
          fontSize: "11px",
          minWidth: { xs: "90px", md: "0px" },
          maxHeight: { xs: "75px", md: "50px" },
          display: "flex",
          flexDirection: "column",
          textAlign: { xs: "center", md: "initial" },
          justifyContent: "flex-start",
          alignItems: { xs: "center", md: "flex-start" },
          borderRadius: "5px",
          gap: { xs: 1, sm: 0 },
          mt: isBrokerageIcon ? { xs: 1.6, md: 0 } : 1.5,
          mb: { xs: 0, md: 4, lg: 3.4 },
          /* The 1px hover shift is direction-aware: it always leans inward. */
          pr: { md: locale === "en" ? 3 : 2 },
          pl: { md: locale === "en" ? 2 : 3 },
          transition: "1s",
          textDecoration: "none",
          "&:hover": {
            pr: { md: locale === "en" ? 2 : 3 },
            pl: { md: locale === "en" ? 3 : 2 },
            textDecoration: "none",
          },
        }}
      >
        <Image
          src={img}
          alt={title || "service"}
          width={50}
          height={50}
          quality={75}
          loading="lazy"
        />

        <Box
          component="p"
          sx={{
            color: "#2d317f",
            fontWeight: "bold",
            fontSize: { xs: "12px", lg: "14px" },
            pt: 0.5,
            textTransform: "capitalize",
          }}
        >
          {title}
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(ServiceTile);
